import { render, staticRenderFns } from "./BoardMain.vue?vue&type=template&id=76f4f1f0"
import script from "./BoardMain.ts?vue&type=script&lang=ts&external"
export * from "./BoardMain.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports